import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpProvider } from 'app/core/common/http-provider.service';
import { PagingConfig } from 'app/core/feature/rest/pagingConfig';

@Injectable({
  providedIn: 'root',
})
export class ApprovalMatrixService extends HttpProvider {

  //#region Endpoint
  private readonly amxEndpoint = '/workflows/matrices/';
  private readonly amxUserListEndpoint = '/workflows/user-matrix-assignment/';
  private readonly amxPreviewEndpoint = '/workflows/matrices/${matrixId}/preview/';
  private readonly amxRequestStatusEndpoint = '/workflows/approval-requests/${request_id}/status/';
  private readonly amxOrgAssignmentEndpoint = '/workflows/org-matrix-assignment/';
  //#endregion

  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  getMatrixList(pagingConfig: PagingConfig, scope: string) {
    const queryParams = {
      scope: scope,
      page_size: pagingConfig.pageSize,
      page: pagingConfig.pageNumber,
    };
    return this.get(this.amxEndpoint, true, {
      params: this.toHttpParams(queryParams),
    });
  }

  getMatrixById(id: number) {
    return this.get(this.amxEndpoint + `${id}/`, true);
  }

  submitMatrix(data) {
    if (data.id != 0) {
      return this.post(this.amxEndpoint + `${data.id}/`, data)
    } else {
      return this.post(this.amxEndpoint, data)
    }
  }

  deleteMatrix(matrixId: number) {
    return this.delete(this.amxEndpoint + `${matrixId}/`);
  }
  
  getUserApprovalMatrix() {
    return this.get(this.amxUserListEndpoint)
  }

  saveUserMatrixAssignment(payload: {
    user_id: number;
    mr_matrix: number;
    er_matrix: number;
    trip_matrix: number;
    uc_matrix?: number;
  }) {
    return this.post(this.amxUserListEndpoint, payload);
  }

  getMatrixPreview(matrixId: number, scope: string = '', user = null) {
    if (matrixId == 0) {
      return this.get(this.amxPreviewEndpoint.replace('${matrixId}', '0'), false, {
        params: this.toHttpParams({ scope: scope, user: user }),
      })
    } else {
      return this.get(this.amxPreviewEndpoint.replace('${matrixId}', matrixId.toString()))
    }
  }

  getApprovalRequestStatus(request_id: number) {
    return this.get(this.amxRequestStatusEndpoint.replace('${request_id}', request_id.toString()))
  }

  assignDefaultMatrix(matrixId: number, scope: string) {
    return this.post(this.amxOrgAssignmentEndpoint, { matrix: matrixId, scope });
  }
}
